import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import "./custom-dropdown-menu.scss";
import { Icons } from "../Icons";
import CustomCheckbox from "../CustomCheckbox";

const createDropdownItems = (dropDownData) => {
  let arr = [];
  arr = dropDownData.map((item, index) => {
    return {
      item,
      eventKey: index,
      option: item.option,
      value: item.value,
    };
  });
  return arr;
};

const handleCheck = (value, toggleMenu) => {
  toggleMenu.map((elem) => {
    {
      elem.value === value
        ? (elem.item.isChecked = true)
        : (elem.item.isChecked = false);
    }
  });
};

const CustomDropdownMenu = (props) => {
  const dropDownItemsArr = createDropdownItems(
    props.dropDownData && props.dropDownData, // eslint-disable-line
  );
  const [dropDownMenu, setDropDownMenu] = useState(
    props.defaultValue, // eslint-disable-line
  );
  const [toggleMenu, setToggleMenu] = useState([]);
  const dropDownType = props.type;
  useEffect(() => {
    setToggleMenu(
      dropDownType === "Learn"
        ? dropDownItemsArr
        : dropDownItemsArr.filter((item) => item.value !== dropDownMenu), // eslint-disable-line
    );
  }, []);

  const setDropDownMenuItem = (key) => {
    setDropDownMenu(key);
    setToggleMenu(
      dropDownType === "Learn"
        ? dropDownItemsArr
        : dropDownItemsArr.filter((item) => item.value !== key), // eslint-disable-line
    );
    props.selectedItem(key);
  };

  return (
    <div className="customed-dropdown-menu">
      <Dropdown
        onSelect={(eventKey) => setDropDownMenuItem(eventKey)}
        className="customed-dropdown"
      >
        <Dropdown.Toggle>
          {dropDownMenu}
          <Icons iconname="chevron-down" variant="icon-twenty-four-px" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="parent-dropdown-menu">
          {toggleMenu.map((data, index) => {
            return (
              <Dropdown.Item
                key={index}
                href="#"
                eventKey={data.value}
                className="child-dropdown-item"
                role="option"
              >
                {data.option === "Action required" ? (
                  <>
                    <Icons iconname="high-priority" variant="icon-sixteen-px" />
                    <span className="ms-2 span-dropdown-items">
                      {data.option}
                    </span>
                  </>
                ) : data.option === "High priority" ? (
                  <>
                    <Icons iconname="alert" variant="icon-sixteen-px" />
                    <span className=" ms-2 span-dropdown-items">
                      {data.option}
                    </span>
                  </>
                ) : dropDownType === "Learn" &&
                  (data.option === "Article" ||
                    data.option === "All" ||
                    data.option === "Video" ||
                    data.option === "Webinar") ? (
                  <>
                    <CustomCheckbox
                      type="checkbox"
                      name="pot"
                      potId="default"
                      variantName="custom-checkbox"
                      checked={data?.item?.isChecked}
                      label={data.option}
                      //checked={true}
                      onChange={() => handleCheck(data.option, toggleMenu)}
                    />
                  </>
                ) : (
                  <span className="span-dropdown-items">{data.option}</span>
                )}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default CustomDropdownMenu;
